import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

function Residence({ id, address, manualPayments, cardPayments, total }) {
  return (
    <Col className="residence-element" id={id}>
      <Row>
        <Col lg={6}>{address}</Col>
        <Col lg={2}>${manualPayments}</Col>
        <Col lg={2}>${cardPayments}</Col>
        <Col lg={2}>${total}</Col>
      </Row>
    </Col>
  );
}

export default Residence;
